import React, { memo, useMemo, lazy, Suspense } from "react";
import { Loading } from "components/shared";
import { useSelector } from "react-redux";
import { LAYOUT_TYPE_CLASSIC } from "constants/theme.constant";
import useAuth from "utils/hooks/useAuth";
import useDirection from "utils/hooks/useDirection";
import useLocale from "utils/hooks/useLocale";
import AuthLayout from "./authLayout";

const layouts = {
  [LAYOUT_TYPE_CLASSIC]: lazy(() => import("./classicLayout")),
};

const Layout = () => {
  const layoutType = useSelector((state) => state?.theme?.layout.type);
  const themeColor = useSelector((state) => state?.theme?.themeColor);
  const primaryColorLevel = useSelector(
    (state) => state?.theme?.primaryColorLevel
  );

  const { authenticated } = useAuth();

  useDirection();

  useLocale();
  const AppLayout = useMemo(() => {
    if (authenticated) {
      return layouts[layoutType];
    }
    return AuthLayout;
  }, [layoutType, authenticated]);
  return (
    <Suspense
      fallback={
        <div
          className={`flex flex-auto flex-col h-[100vh] items-center justify-center bg-${themeColor}-${primaryColorLevel}`}
        >
          <Loading loading={true} spinnerClass="text-white" />
        </div>
      }
    >
      <AppLayout />
    </Suspense>
  );
};

export default memo(Layout);
